import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import PageContext from '@contexts/pageContext'

import CreateServiceProductModal from '@modals/CreateServiceProductModal'

import PageContent from './components/PageContent'

const callbacks = (component, setState) => {
  const componentCallbacks = {
    CreateServiceProductModal: {
      closeModal: () => setState({ showCreateServiceProductModal: false }),
      createServiceProduct: payload => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateServiceProductModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateServiceProductModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateServiceProductModal: () => setState({ showCreateServiceProductModal: true }),
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateServiceProductModal
          callbacks={callbacks('CreateServiceProductModal', setState)}
          showModal={showCreateServiceProductModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
